import dayjs from 'dayjs'

const horariosDesabilitados = [
    '05:00', // Backup integral
    '06:00', // Backup parcial
    '17:00', // Backup integral
].map(h => dayjs.utc(`2000-01-01T${h}:00Z`).local().format('HH:mm'))

export const horariosCalculoAutomatico = Array.from(
    { length: 48 },
    (_, index) => {
        const hora = Math.floor(index / 2)
        const minuto = index % 2 === 0 ? '00' : '30'
        return `${hora.toString().padStart(2, '0')}:${minuto}`
    },
).filter(horario => !horariosDesabilitados.includes(horario))
